import { render } from "./CommentPanel.vue?vue&type=template&id=aaf11d72"
import script from "./CommentPanel.vue?vue&type=script&lang=js"
export * from "./CommentPanel.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\Administrator.1LIZRQUYRIVXOVB\\github-classroom\\MUICCS\\cs340prj-Atiwat-R\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__